module.exports = __webpack_public_path__ + "img/icon-1.49f8f06d.png";